import React, { useState, useRef } from 'react'
import PlayersCount from './players-count'
import PlayersTable from './players-table'

export default function GameDetails(props) {
  const { game, playerReservations } = props
  const [editCost, setEditCost] = useState(false)
  const costInputRef = useRef(null)
  const gameCost = parseFloat(game.cost)
  const paidAmount = parseFloat(game.paid_amount)
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const gameName = () => {
    return <blockquote className='blockquote' onClick={props.onEdit}>
      <div className='game-title'>
        {game.displayed_name}
        { game.linked && <div className='game-linked'></div> }
      </div>
      <footer>
        {game.full_time}&nbsp;
        <span className='fa fa-pencil'></span>
      </footer>
      
      { !game.special_event &&
        <footer>
          {game.numbered_field_name}&nbsp;
          { game.field_name && <span className='field-title-subname'>({game.field_name})</span> }
        </footer>
      }
    </blockquote>
  }

  const changeCost = () => {
    const cost = costInputRef.current.value
    if (cost < 0 || cost > 1000000) return

    if (gameCost != cost) props.onEditCost(cost)
    setEditCost(false)
  }
  
  return <div>
    <div className='row'>
      <div className='col-md-6'>
        <a className='edit-reservation-link clickable'>{gameName()}</a>
      </div>

      <div className='col-md-3'>
        <div className='panel panel-info'>
          <div className='panel-heading'>{`Total Price${currencyName}:`}</div>
          <div className='panel-body game-edit-cost-wrapper'>
            { !editCost &&
              <div className='toggle-cost-edit'>
                <span className='total-reservation-cost'>$ {gameCost.toFixed(2)}</span>&nbsp;
                { props.priceEditable && <span className='fa fa-pencil' onClick={() => setEditCost(true)}></span> }
              </div>
            }
            { editCost &&
              <form>
                <div className='dollar-field inline'>
                  <input step='0.01' className='form-control' type='number' 
                    autoFocus ref={costInputRef} onBlur={() => setTimeout(() => { setEditCost(false) }, 300)} />
                </div>&nbsp;
                <input type='submit' name='commit' value='OK' className='btn btn-info' 
                  onClick={(e) => {e.preventDefault(); changeCost()}} />
              </form>
            }
          </div>
        </div>
      </div>

      <div className='col-md-3'>
        <div className='panel panel-success'>
          <div className='panel-heading'>{`Current Balance${currencyName}:`}</div>
          <div className='panel-body current-reservation-balance'>$ {parseFloat(game.balance).toFixed(2)}</div>
        </div>
      </div>
    </div>

    { paidAmount == 0 && 
      <PlayersCount currentCount={playerReservations.length} onChangePlayersCount={props.onPlayersCount} /> 
    }

    <PlayersTable 
      game={game}
      playerReservations={playerReservations}
      onRenamePlayer={props.onRenamePlayer}
      onEditCost={props.onEditPlayerCost}
      onDeletePlayer={props.onDeletePlayer}
      onShowPlayer={props.onShowPlayer}
      onShowReceipt={props.onShowReceipt}
      onRefundPaidFor={props.onRefundPaidFor}
      onRefund={props.onRefund}
      onPayment={props.onPayment}
      onChangeReservation={props.onChangeReservation}
    />
    <div className='add-player-container'>
      <a className='clickable' onClick={props.onAddPlayer}>
        <i className='fa fa-plus'></i>&nbsp;Add a player
      </a>
    </div>
  </div>
}
